var locale = {
  placeholder: 'Select time'
};
export default locale;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/time-picker/locale/en_US.js
// module id = 242
// module chunks = 14